import type { Card } from '~/@types/card'

import PrismicRichText from '~/components/Abstracts/Prismic'

import serializeImage from '~/data/serialize-image'

import serializeLink from './serialize-link'

export default function serializeCard(slice, locale): Card {
  return slice?.data
    ? {
        name: PrismicRichText.asText(slice?.data?.card_name) ?? null,
        label: slice?.data?.card_label ?? null,
        image: serializeImage(slice?.data?.card_image) ?? null,
        imageHover: serializeImage(slice?.data?.card_image_hover) ?? null,
        link: serializeLink(slice, locale) ?? null,
        pin: slice?.data?.card_pin ?? null,
      }
    : null
}
